<template>
    <div class="container-fluid dv-login"
         :class="{'dv-login-admin':props.type === 1,
                  'dv-login-customer':props.type === 2}">
        <form id="frmLogin" 
              autocomplete="off"               
              @submit.prevent="onLogin">
            <div class="row">
                <div class="w-100" style="text-align: center;">
                    <h3>{{ $t('Login.Title') }}</h3>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 mt-3  control-container">                      
                    <label class="form-label">{{ $t('Login.Usuario') }}</label>
                    <InputText id="txtUser" :class="{'ng-invalid ng-dirty':errors.userId}"
                                v-model="userId">
                    </InputText>                    
                    <ErrorMsg :error="errors.userId"></ErrorMsg>                    
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 mt-3  control-container">                      
                    <label class="form-label">{{ $t('Login.Contrasena') }}</label>
                    <input type="password" 
                        class="p-inputtext" 
                        :class="{'ng-invalid ng-dirty':errors.clave}"
                        v-model="clave"> 
                    <ErrorMsg :error="errors.clave"></ErrorMsg>
                </div>
            </div>
            <div class="row d-none" >
                <div class="inline-block dv-options ">
                    <Checkbox v-model="keepSesion" :binary="true" inputId="keepSession"/>
                    <label class="pointer"  for="keepSession">&nbsp;&nbsp;{{ $t('Login.KeepSesion') }}</label>
                </div>
            </div>
           
            <div class="row d-none">
                <div class="dv-options-2 pointer">
                    {{ $t('Login.ForgotPass') }}
                </div>
            </div>
            <div class="row  col-12 mt-3 mb-3 dv-notificacion "
                 :class="{'dv-notificacion-ok':serverResponse.tipo === eStatusCode.Ok ,
                         'dv-notificacion-error':serverResponse.tipo !== eStatusCode.Ok}" 
                 v-if="serverResponse && serverResponse.msg">
                {{serverResponse.msg}}
            </div>
            <div class="row mt-3" v-if="!props.loading">
                <div class="form-group">
                    <div class="loginButton">
                        <Button type="submit">
                            {{ $t('Login.Entrar') }}
                        </Button>
                    </div>
                </div>
            </div>
            <div class="row col-12 text-center mt-5" style="color:var(--color-primary)" v-else>                
                <i class="pi pi-spin pi-spinner" style="font-size: 110%;margin-right: 7px;"></i>
                <b>{{$t('globals.espere')}}</b>
            </div>
        </form>
    </div>
</template>
<script setup lang="ts">
import InputText from 'primevue/inputtext';
import ErrorMsg from '@/views/shared/ErrorMsg.vue';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { toTypedSchema } from '@vee-validate/yup';
import { traduceTexto } from '@/core/services/base/GlobalFunctios';
import { PropType, onMounted } from 'vue';
import { defineEmits,defineProps } from 'vue';
import { eStatusCode } from '@/core/model/GloblasEnum';

interface IServerResponse {
  tipo: number,
  msg: string  
}
const props = defineProps(
{ 
 type:Number,
 serverResponse: Object as PropType<IServerResponse>,
 loading:Boolean
});
const emits = defineEmits(['onLogin']);
const { errors,handleSubmit, defineField } = useForm(
{
    validationSchema: toTypedSchema(
    yup.object(
    {
        userId: yup.string().required(traduceTexto('globals.requerido')),
        clave: yup.string().required(traduceTexto('globals.requerido')),
        keepSesion:yup.boolean()
    })),
});
const [userId] = defineField('userId');
const [clave] = defineField('clave');
const [keepSesion] = defineField('keepSesion');
const onLogin = handleSubmit((values) => 
{          
    emits('onLogin',values); 
});
onMounted(()=>
{
   const inputField: HTMLElement|null = document.getElementById('txtUser');
   inputField && inputField.focus();
});
</script>
<style scoped>
.dv-login
{
    width: 320px;
    margin: auto;   
    background-color: transparent; 
}
.loginButton
{
    width: fit-content;
    margin: auto;
}
.dv-options
{
    margin-top: 1rem;
    margin-bottom: 1rem;
}
.dv-options-2
{
    width: 100%;
    margin-bottom: 1rem;   
    text-align: right;    
}
.dv-login-admin
{
 color: var(--color-text-app-terciary);
}
.dv-login-customer
{
  color: var(--color-text-app-terciary);
}
.dv-login-admin .loginButton
{
    border: 1px solid var(--color-text-app-terciary);
}
</style>